import { commonEnvironment, resolveDeployEnv } from './environment.common';
import { orignalEnvironmentPord } from './orignal/orignal-environment.prod';

const apiUrl = window.location.origin;

const production = true;
const version = 'prod.20261022.1';
/**是否为prod环境 */
const isOnline = ('true' as string) === 'true';
/**是否是sit环境 */
const isSit = ('false' as string) === 'true';
/**是否是uat环境 */
const isUat = ('false' as string) === 'true';

export const environment = {
  production,
  common: {
    tenant: '8',
    ...commonEnvironment,
  },
  version,
  isOnline,
  isSit,
  isUat,
  /**部署阶段,由上面的旗标推导。使用端直接读 environment.env,不需自行判断 */
  env: resolveDeployEnv({ production, version, isSit, isUat, isOnline }),
  apiUrl: apiUrl,
  resourceUrl: '#{resourceUrl}#',
  softSwissConnectorScriptUrl: 'https://s3.eu-central-1.amazonaws.com/ignition.button/round-2/connector.js',
  signalrUrl: apiUrl + '/ws',
  chatSignalrUrl: apiUrl + '/im/ws',
  rsaPublicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoTgcVORkxBPRQJimRKTUHrSS+vTBzbAm8l6bwaFqr1Mya/pjsHrUPCErJnchMfmfgEBFrsfX5/FLGfXvKFT//F949jgcl3My2oGCOk4dTh+zpp16q8e0qoOG5JtKmQjs2W+s2sAp2Xsk4hMfRY9ZzxsSORjS6YYvgLb0TwbLXZ1GAHhwJSVJS38AUqJH2Z0ng7xzDAklEqLfcP+99PBVau0iqRBEypUsJqcTPXTJMQw0wZg3Frci0SuOhTexmG7NzVhHZIV0cp07czo8lp8+2YvC14iaPwn2xB4dVXNtIILQFXorfNS9U+IO5uL0Y432GeWax1tVXrl6jowihrd1nwIDAQAB',
  /**原创相关 */
  orignal: orignalEnvironmentPord,
  cacheKey: '3',
  /**是否为App */
  isApp: false,
  translateUrl: '/configs3/LanguageTranslate/Web8/[lang].json,/configs2/LanguageTranslate/Web8/[lang].json,/configs/LanguageTranslate/Web8/[lang].json',
  configUrls: '/configs3/web-[tenant].json,/configs2/web-[tenant].json,/configs/web-[tenant].json',
  sentryDsn: 'https://12d02a138547fa8d1c545e50c89037fc@sentry.athena25.com/17',
  /**是否为欧洲版 */
  //@ts-ignore
  isEur: 'false' == 'true',
  sendbirdAPPId: '26E9D2D6-5363-460B-9EAC-200C17D2876F',
};
